import { render, staticRenderFns } from "./Subventionsbeitraege.vue?vue&type=template&id=6c5e0a63"
import script from "./Subventionsbeitraege.vue?vue&type=script&lang=js"
export * from "./Subventionsbeitraege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports